export const containsDrivers = (vehicleIds: (number | string)[], vehicleSummary: any): boolean => {
    return vehicleIds.length ? vehicleIds.some((id) => id === vehicleSummary.id) : true;
};

export const containsGroups = (groupIds: (number | string)[], vehicleSummary: any): boolean => {
    return groupIds.length ? groupIds.some((id) => id === vehicleSummary.group) : true;
};
